import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import { toast } from 'react-toastify';
import qs from 'qs';
import { statusOptions } from '../../../helpers';

import PageTitle from '../../common/PageTitle';
import Checkbox from '../../common/Checkbox';
import Button from '../../common/Button';
import SelectComponent from '../../common/Select';
import DatePicker from '../../common/DatePicker';

import { fetchGetOrdersCount, fetchGetOrdersReport, fetchTags } from '../../../actions/orders';

import { ORDERS_EXPORT_PAGE_LABELS, ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS } from '../../../config';
import InputWrapper from '../../common/InputWrapper';

const Wrapper = styled(`div`)`
  .parameters-wrapper {
    display: flex;
    margin-bottom: 30px;
  }

  .divider-wrapper {
    margin: auto 10px 10px;
    font-weight: bold;
  }

  .parameter-wrapper {
    flex-basis: 23.375%;
    max-width: 235.885px;

    label {
      display: block;
    }

    &--wide {
      flex-basis: 50%;
      max-width: 500px;
      min-width: 210px;
    }

    .form-control {
      min-height: 38px;
    }

    .react-datepicker-wrapper {
      width: 100%;
      height: 38px;

      .react-datepicker__input-container {
        height: 100%;

        input {
          height: 100%;
        }
      }
    }
  }

  .options-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .custom-control-label {
      margin-right: 45px;
      margin-bottom: 15px;
    }
  }

  .buttons-wrapper {
    padding-top: 24px;
    position: relative;
    display: flex;

    &::before {
      content: '';
      position: absolute;
      left: -24px;
      top: 0;
      width: calc(100% + 48px);
      border-bottom: 1px solid #f1f5f8;
    }
  }

  .counter-title {
    margin: 3px 0 11px;
    font-size: 11px;
    color: #98a6ad;
    font-weight: 600;
  }

  ul {
    padding-left: 15px;
  }
`;

const getOrderTypeData = (exportType) => {
  if (exportType === 'standard') {
    return {
      orderType: 'STANDARD',
    };
  }

  if (exportType === 'subscription') {
    return {
      orderType: 'CUSTOM',
      orderSubType: 'KAK2C_SUBSCRIPTION',
    };
  }

  return {};
};

const ExportPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { tags } = useSelector((state) => state.orders);

  const [extendedAddress, setExtendedAddress] = useState(false);
  const [exportTags, setExportTags] = useState(true);
  const [exportItems, setExportItems] = useState(false);
  const [exportPackages, setExportPackages] = useState(false);
  const [exportPackedItems, setExportPackedItems] = useState(false);
  const [exportTechData, setExportTechData] = useState(false);
  const [searchDateType, setSearchDateType] = useState({
    label: `Дата создания`,
    value: `CREATE_DATE`,
  });
  const [fromDate, setFromDate] = useState(
    moment().subtract(1, `days`).format(`YYYY-MM-DD HH:mm:ss`),
  );
  const [toDate, setToDate] = useState(moment().format(`YYYY-MM-DD HH:mm:ss`));
  const [loadingReport, setLoadingReport] = useState(false);
  const [result, setResult] = useState();
  const [count, setCount] = useState();
  const [exportType, setExportType] = useState(``);
  const [statuses, setStatuses] = useState([]);
  const [deliveryInfos, setDeliveryInfos] = useState([]);
  const [orderTags, setOrderTags] = useState([]);
  const [city, setCity] = useState(``);
  const [variantId, setVariantId] = useState(``);
  const [promocode, setPromocode] = useState(``);

  useEffect(() => {
    const params = qs.parse(history.location.search.slice(1));
    if (params.export_type) {
      setExportType(params.export_type);
    }
  }, [history.location.search]);

  useEffect(() => {
    setResult(undefined);

    const orderTypeData = getOrderTypeData(exportType);

    if (!exportType) return;

    dispatch(
      fetchGetOrdersCount({
        extendedAddress,
        exportTags,
        exportItems,
        exportPackages,
        exportTechData,
        searchDateType: searchDateType.value,
        fromDate,
        toDate,
        statuses: statuses.map(({ value }) => value),
        deliveryInfos: deliveryInfos.map(({ value }) => value),
        orderTags: orderTags.map(({ value }) => value),
        city,
        variantId,
        promocode,
        ...orderTypeData,
      }),
    ).then(({ count, limit }) => {
      setCount(count);
      if (count > limit)
        toast.warn(
          `Будет выгружено только 3000 заказов с товарами / 30 000 заказов без товаров, в зависимости от настройки экспорта`,
        );
    });
  }, [
    city,
    deliveryInfos,
    dispatch,
    exportItems,
    exportPackages,
    exportTags,
    exportTechData,
    exportType,
    extendedAddress,
    fromDate,
    orderTags,
    promocode,
    searchDateType.value,
    statuses,
    toDate,
    variantId,
  ]);

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);

  const handleGetReport = async () => {
    setLoadingReport(true);

    const orderTypeData = getOrderTypeData(exportType);

    try {
      await dispatch(
        fetchGetOrdersReport({
          extendedAddress,
          exportTags,
          exportItems,
          exportPackages,
          exportPackedItems,
          exportTechData,
          searchDateType: searchDateType.value,
          fromDate,
          toDate,
          statuses: statuses.map(({ value }) => value),
          deliveryInfos: deliveryInfos.map(({ value }) => value),
          orderTags: orderTags.map(({ value }) => value),
          city,
          variantId,
          promocode,
          ...orderTypeData,
        }),
      );
      history.push('/orders-export');
      setLoadingReport(false);
    } catch {
      setLoadingReport(false);
    }
  };

  const { deliveryInfo } = useSelector((state) => state.orders);
  const deliveryOptions = Array.from(
    deliveryInfo
      .map((item) => {
        let label = '';

        if (item.fbmType && item.title) {
          label = `FBM ${item.fbmType} - поставка на маркетплейс (${item.title})`;
        } else if (item.type === 'SELF_PICKUP') {
          label = `${item.courierTitle} (${item.title})`;
        } else {
          label =
            (item.courierTitle ? item.courierTitle : ``) +
            (item.product ? `: ${item.product}` : ``);
        }

        if (item.title && !item.fbmType) label += ` (${item.title})`;

        return {
          value: item.code,
          label,
        };
      })
      .sort((a, b) => (a.label > b.label ? 1 : -1)),
  );

  const tagsOptions = tags?.map(({ name }) => ({ value: name, label: name }));

  return (
    <>
      <PageTitle title="Экспорт заказов" />
      <Wrapper className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <p className="card-subtitle">Настройки отбора заказов</p>
              <p className="counter-title">Заказов в выборке: {count}</p>
              <div className="parameters-wrapper">
                <div className="parameter-wrapper">
                  <label className="">Дата от</label>
                  <DatePicker
                    showTimeSelect
                    dateFormat="dd.MM.yyyy HH:mm"
                    id="export-date-from"
                    selected={moment(fromDate, `YYYY-MM-DD HH:mm`).toDate()}
                    onChange={(date) => setFromDate(moment(date).format(`YYYY-MM-DD HH:mm:ss`))}
                  />
                </div>
                <div className="divider-wrapper">–</div>
                <div className="parameter-wrapper">
                  <label className="">Дата по</label>
                  <DatePicker
                    showTimeSelect
                    dateFormat="dd.MM.yyyy HH:mm"
                    id="export-date-to"
                    selected={moment(toDate, `YYYY-MM-DD HH:mm`).toDate()}
                    onChange={(date) => setToDate(moment(date).format(`YYYY-MM-DD HH:mm:ss`))}
                  />
                </div>
                <div className="parameter-wrapper parameter-wrapper--wide ml-3">
                  <SelectComponent
                    label={
                      <>
                        {ORDERS_EXPORT_PAGE_LABELS.searchDateType}
                        <span className="help-tooltip-wrapper">
                          <i className="fe-help-circle" />
                          <span className="help-tooltip">
                            Сочетание метода отбора и дат позволяет получить список заказов с
                            нужными параметрами:
                            <ul>
                              <li>по дате создания заказов</li>
                              <li>по дате отгрузки заказов</li>
                              <li>по дате фактической доставки заказов</li>
                              <li>по дате возврата</li>
                            </ul>
                          </span>
                        </span>
                      </>
                    }
                    onChange={(value) => setSearchDateType(value)}
                    value={searchDateType}
                    options={ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS}
                  />
                </div>
              </div>
              <p className="block-subtitle">Дополнительные настройки</p>
              <div className="parameters-wrapper mb-3">
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide">
                  <SelectComponent
                    isMulti
                    label="Статус заказа"
                    onChange={(value) => setStatuses(value || [])}
                    value={statuses}
                    options={statusOptions}
                  />
                </div>
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide ml-3">
                  <SelectComponent
                    isMulti
                    label="Служба доставки"
                    onChange={(value) => setDeliveryInfos(value || [])}
                    value={deliveryInfos}
                    options={deliveryOptions}
                  />
                </div>
              </div>
              <div className="parameters-wrapper mb-3">
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide">
                  <SelectComponent
                    isMulti
                    label="Метки"
                    onChange={(value) => setOrderTags(value || [])}
                    value={orderTags}
                    options={tagsOptions}
                  />
                </div>
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide ml-3">
                  <InputWrapper
                    label="Населённый пункт"
                    placeholder="Город, регион"
                    value={city}
                    onChange={(evt) => setCity(evt.target.value)}
                  />
                </div>
              </div>
              <div className="parameters-wrapper mb-3">
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide">
                  <InputWrapper
                    label="ID варианта"
                    value={variantId}
                    onChange={(evt) => setVariantId(evt.target.value)}
                  />
                </div>
                <div className="parameter-wrapper parameter-wrapper--select parameter-wrapper--wide ml-3">
                  <InputWrapper
                    label="Промокод"
                    value={promocode}
                    onChange={(evt) => setPromocode(evt.target.value)}
                  />
                </div>
              </div>
              <p className="block-subtitle">Выгружаемые данные</p>
              <div className="options-wrapper">
                <Checkbox
                  label={ORDERS_EXPORT_PAGE_LABELS.exportTags}
                  id="export-exportTags"
                  checked={exportTags}
                  onChange={(evt) => setExportTags(evt.target.checked)}
                />
                <Checkbox
                  label={
                    <>
                      {ORDERS_EXPORT_PAGE_LABELS.exportItems}
                      <span className="help-tooltip-wrapper">
                        <i className="fe-help-circle" />
                        <span className="help-tooltip">
                          Может значительно замедлить экспорт, имеется ограничение в 1000 записей
                        </span>
                      </span>
                    </>
                  }
                  id="export-exportItems"
                  checked={exportItems}
                  onChange={(evt) => setExportItems(evt.target.checked)}
                />
                <Checkbox
                  label={ORDERS_EXPORT_PAGE_LABELS.extendedAddress}
                  id="export-extendedAddress"
                  checked={extendedAddress}
                  onChange={(evt) => setExtendedAddress(evt.target.checked)}
                />
                <Checkbox
                  label={ORDERS_EXPORT_PAGE_LABELS.exportPackages}
                  id="export-exportPackages"
                  checked={exportPackages}
                  onChange={(evt) => setExportPackages(evt.target.checked)}
                />
                <Checkbox
                  label={ORDERS_EXPORT_PAGE_LABELS.exportPackedItems}
                  labelQuestion="Информация только для отгруженных заказов за указанный период"
                  id="export-exportPackedItems"
                  checked={exportPackedItems}
                  onChange={(e) => setExportPackedItems(e.target.checked)}
                />
                <Checkbox
                  label={ORDERS_EXPORT_PAGE_LABELS.exportTechData}
                  id="export-exportTechData"
                  checked={exportTechData}
                  onChange={(evt) => setExportTechData(evt.target.checked)}
                />
              </div>
              <div className="buttons-wrapper">
                <Button
                  text="Начать экспорт"
                  className="mr-3"
                  loading={loadingReport}
                  onClick={handleGetReport}
                />
                {result ? (
                  <div>
                    Файл сформирован:{' '}
                    <a href={result.fileUrl} target="_blank" rel="noopener noreferrer">
                      {result.fileID}
                    </a>
                    <br />
                    Дата выгрузки: {result.finishTime}, размер файла: {result.fileSize}
                  </div>
                ) : (
                  loadingReport && (
                    <div>
                      Формирование файла с товарами –<br />
                      пожалуйста, дождитесь окончания операции
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default ExportPage;
